import type {ExtractPropsWithoutRef} from '@/types';

import styled from '@emotion/styled';
import {IconClose} from '@travel-frontend/icons';
import {IconButton} from '@travel-frontend/ui-components';
import {forwardRef} from 'react';

import {Container} from '@/components/FilterDrawer/components/Header/components/Container';

type Props = React.PropsWithChildren<
  {
    onClose: () => void;
  } & ExtractPropsWithoutRef<typeof Container>
>;

export const Header = styled(
  forwardRef<HTMLDivElement, Props>(function HeaderComponent(
    {children, onClose, ...restProps},
    ref
  ) {
    return (
      <Container {...restProps} ref={ref}>
        {children}
        <IconButton round variant="info" category="tertiary" onClick={onClose}>
          <IconClose />
        </IconButton>
      </Container>
    );
  })
)``;
